export default {
  action_to_realize: "Acciones necesarias",
  sign_action: "Guardar y firmar",
  complete: "Rellenar",
  toComplete: "Pendiente",
  due_date: "Fecha límite",
  toSign: "Para firmar",
  description: "Descripción",
  yearProgression: "Progreso del año",
  progression: "Progreso",
  your_progression: "Su nivel de progreso",
  triad_progression: "Tasa de respuesta de trinomio",
  question: "Pregunta",
  incoming: "En espera",
  signature: "Firma",
  questionnaire: "Cuestionario",
  questionnaires: "Cuestionarios",
  yourAnswer: "Su respuesta: ",
  answerHere: "Responda aquí",
  commentHere: "Deje un comentario aquí",
  comment: "Comentar la respuesta",
  answerComment: "Responder al comentario",
  sendComment: "Publicar el comentario",
  sign: "Firmar",
  draft: "Guardar como borrador",
  sharedDraft: "Guardar y compartir",
  stopSharedDraft: "Dejar de compartir el borrador",
  stopSharedDraft_success: "Compartición del borrador desactivada",
  downloadPdf: "Descargar el cuestionario",
  downloadPdfModel: "Descargar el modelo",
  interviewDate: "Fecha de visita a empresa",
  youAnswered: "Ha respondido:",
  sendFile: "Enviar un archivo",
  sendDocument: "Enviar un documento",
  takePicture: "Hacer foto",
  fileSource: "Origen del archivo",
  yesSign: "Sí, firmo",
  questionnaire_remove_title: "Eliminar un cuestionario",
  questionnaire_remove_sub_title: "¿Confirma que quiere eliminar este cuestionario?",
  copy_questionnaire: "Copiar el cuestionario",
  questionnaire_copy_success: "Cuestionario copiado correctamente",
  questionnaire_removed_success: "Cuestionario eliminado correctamente",
  questionnaires_copied: "Versiones del cuestionario anterior",
  signMessage: "¿Confirma que quiere firmar el cuestionario? Después ya no podrá modificar sus respuestas.",
  row_add_success: "Línea añadida correctamente",
  comment_add_success: "Comentario añadido correctamente",
  deleteMessage: "¿Confirma que quiere eliminar esta línea?",
  download_report: "Descargar el informe",
  signatory: "Firmado por",
  signatories: "Firmantes",
  expected_signature: "Tiene que firmarse antes del",
  signed_on: "Firmado el",
  commented_by: "Comentado por",
  success: "Guardado correctamente",
  draftSuccess: "Borrador guardado correctamente",
  sharedSuccess: "Borrador compartido correctamente",
  signedSuccess: "Firmado correctamente",
  deletedQuestionnaire: "Este cuestionario se ha eliminado",
  addLine: "Añadir una fila",
  "Competence calculated by your answers to the questionnaires":
    "Competencia calculada según sus respuestas a los cuestionarios",
  open_from: "Disponible desde",
  no_crew_dates: "Sin fechas para el grupo",
  open_to: "al",
  marks: "Notas",
  block_sign: "El cuestionario solo se puede firmar después de que los otros miembros del trinomio lo validen.",
  no_mark: "Sin nota de momento",
  "Download dates": "Descargar las fechas",
  "Print all the questionnaires": "Imprimir todos los cuestionarios",
  answered: "ha respondido el",
  remove_answer_title: "Eliminación de una línea",
  remove_answer: "¿Seguro que quiere eliminar esta línea de respuesta?",
  to_be_completed_from: " Completar a partir de ",
  to: " al ",
  open_at: "Disponible el ",
  closed_at: "Clôturé au ",
  reopened: "Questionnaire ré-ouvert",
  signed_at: "Signé le ",
  export_questionnaire: "Exportar el cuestionario",
  import_questionnaire: "Importar un cuestionario",
  no_questionnaire: ({ plural }) =>
    plural([
      "No se ha respondido ningún cuestionario para este año",
      "No se ha respondido ningún cuestionario para esta categoría",
    ]),
  note: {
    title: ({ plural }) => plural(["Nota", "Notas"]),
    question: {
      title: "Nota sobre la pregunta",
    },
    cluster: {
      title: "Nota de la tabla",
    },
    questionnaire: {
      title: "Notas del cuestionario",
    },
    use_note_for_questionnaire: {
      title: "Incorporar la nota en la nota final del cuestionario.",
    },
    coefficient: "Coeficiente",
    coefficient_help:
      "Permite ponderar la importancia de esta rúbrica en relación con las demás rúbricas del cuestionario." +
      "\n Ejemplo: Tienes 2 rúbricas" +
      "\n - Rúbrica 'Teórica' con coeficiente 2" +
      "\n - Rúbrica 'Práctica' con coeficiente 3" +
      "\n La rúbrica 'Práctica' contará 1,5 veces más en la nota final.",
    coefficient_question_help: "Multiplicador aplicado a la nota final de esta rúbrica",
    convertion: "Baremo de la nota final",
    convertion_help:
      "Define el baremo sobre el cual se ajustará la nota final después de calcular el promedio de todas las preguntas de esta rúbrica." +
      "\n Ejemplo: Tienes 5 preguntas calificadas sobre 2 puntos cada una." +
      "\n - Si indicas 20, el promedio se convertirá a una nota sobre 20." +
      "\n - Si el estudiante obtiene 8/10, su nota final será 16/20.",
    convertion_question_help: "La nota de esta pregunta se convertirá según este baremo",
    question_conversion: "Baremo por pregunta",
    question_conversion_help:
      "Define el baremo de visualización para cada pregunta de esta rúbrica. ¡La nota obtenida no puede superar los puntos máximos de la pregunta!" +
      "\n Caso 1: Pregunta sobre 5 puntos" +
      "\n - Baremo por pregunta = 20" +
      "\n Las notas mostradas serán: 5/20, 4/20, 3/20, etc. (la nota sigue limitada a los 5 puntos)." +
      "\n Caso 2: Pregunta sobre 5 puntos" +
      "\n - Baremo por pregunta = 4" +
      "\n Las notas estarán limitadas: 4/4, 3/4, 2/4, etc. (los 5 puntos posibles se reducen a un máximo de 4).",
    question_conversion_question_help: "Nota máxima posible para esta pregunta",
    see_details: "Ver el detalle de las notas",
    details: "Detalle",
    mark_detail: "Detalle de las notas",
    average: "Media",
    mark_scale: "Escala salarial",
    maximal_mark: "Nota máxima",
    minimal_mark: "Nota mínima",
    maximal_mark_upper_than_mark_converted: "La nota máxima no puede ser superior a la nota mostrada.",
    maximal_mark_for_question: "La puntuación máxima para esta pregunta es:",
    maximal_mark_with_value: "Puntuación máxima : {mark1}/{mark2}",
    error: {
      no_genral_mark:
        "El sistema de puntuación está activado para esta pregunta. Introduzca también la escala general del cuestionario haciendo clic aquí.\n",
    },
    leave_empty: "Dejar vacío si la nota máxima es la misma que en la lista de opciones.",
  },
  summary_sheet: {
    title: "Resumen de notas",
    average: "Nota media",
  },
  empty_comment_label: "Commentaire",
  completeness_date_between_triad_start_date_and_end_date:
    "La fecha de finalización debe estar comprendida entre las fechas de apertura y cierre de los miembros del trinomio.",
  lock_questionnaire_heading: "Bloquear/desbloquear la posición del encabezado",
  use_contract_date: "Apertura según las fechas de los contratos activos de los tríos",
};
